import { useEffect, useState } from 'react';
import { loadBigNumberJS, loadDayjs, loadLodash } from '@icp/utils';

const loadMap = {
  'bignumber.js': loadBigNumberJS,
  lodash: loadLodash,
  dayjs: loadDayjs,
};

export default function useThirdLibraries(names) {
  const [loading, setLoading] = useState(Array.isArray(names) && names.length > 0);
  const [libraries, setLibraries] = useState({});

  useEffect(() => {
    if (!(Array.isArray(names) && names.length > 0)) {
      return;
    }
    Promise.all(names.map((key) => loadMap[key]())).then((data) => {
      setLibraries(
        Object.fromEntries(
          names.map((key, index) => {
            return [key === 'bignumber.js' ? 'BigNumber' : key, data[index]];
          }),
        ),
      );
      setLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [String(names)]);

  return [loading, libraries];
}
